import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { FileService } from 'src/app/services/file.service';
import { FormServices } from 'src/app/services/form-services.service';
import { HttpService } from 'src/app/services/http.service';
import { UiServices } from 'src/app/services/ui-services';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-slider-images',
  templateUrl: './slider-images.component.html',
  styleUrls: ['./slider-images.component.scss'],
})
export class SliderImagesComponent implements OnInit, OnDestroy {
  @Input() set edit(value: any[]) {
    if (value) {
      this._isCopy = false;
      this.imagesUploaded = {};
      this.imagesUploadInSave = {};
      value.map((img) => {
        !this.imagesUploadInSave[this.type] &&
          (this.imagesUploadInSave[this.type] = []);

        if (this.isCatalogue) {
          if (img[this.type]) {
            img.url = img[this.type];
            this.imagesUploadInSave[this.type] = [img.url];
            this.setImages(img[this.type]);
          }
        } else if (img.file) {
          img.url = img?.file;
          this.imagesUploadInSave[this.type].push(img.url);
        }
      });
      if (!this.isCatalogue) {
        this.setImages(value);
      }
    }

    if (!this.fileService.copy) {
      this.imagesUploaded = {};
      this.imagesUploadInSave = {};
      this.saveImg.emit(this.imagesUploadInSave);
    }
  }
  @Input() type = 'products';
  @Input() id: number = undefined;
  @Input() isCatalogue: boolean;
  @Input() multiple = undefined;
  @Input() saveInUpload = undefined;
  @Output() saveImg = new EventEmitter();
  @Output() removeImg = new EventEmitter();
  public imagesUploaded = {};
  public imagesUploadInSave = {};
  public imagesUploadedRes = {};
  public imagesUploadInSaveRes = {};
  public isSending = false;
  public imgUrl = environment.uriProduct;
  public defaultImg = environment.defaultImg;
  public uploadingImage = false;
  public fixedType = '';
  private _subscription: Subscription = new Subscription();
  private _isCopy = false;

  constructor(
    private httpSv: HttpService,
    private fileService: FileService,
    private uiSv: UiServices,
    private formSv: FormServices,
    private translateSv: TranslateService
  ) {}

  ngOnInit() {
    this.fixedType = this.type;
    this._subscription.add(
      this.fileService.copyObs.subscribe(() => {
        setTimeout(() => {
          this.imagesUploaded = this.imagesUploadedRes;
          this.imagesUploadInSave = this.imagesUploadInSaveRes;

          this.saveImg.emit(this.imagesUploadInSave);
          this._isCopy = true;
        }, 500);
      })
    );

    if (this.type === 'imageOptions') {
      this.fixedType = 'products';
    } else if (
      this.type === 'bannerCatalogue' ||
      this.type === 'forntCatalogue' ||
      this.type === 'catalogues'
    ) {
      this.fixedType = 'catalogues';
    }

    this._subscription.add(
      this.formSv.clearFormObs.subscribe((data) => {
        this.imagesUploadInSave = {};
        this.imagesUploaded = {};
      })
    );
  }

  ngOnDestroy(): void {
    this._subscription.unsubscribe();
  }

  setImages(value) {
    this.imagesUploadInSaveRes = this.imagesUploadInSave;
    if (this.fileService.copy) {
      // this.saveImg.emit(this.imagesUploadInSave);
    }
    setTimeout(() => {
      this.imagesUploaded[this.type] ?? (this.imagesUploaded[this.type] = []);
      if (this.isCatalogue) {
        this.imagesUploaded[this.type] = [{ url: value }];
      } else {
        value = value.filter((x) => x.url);
        this.imagesUploaded[this.type].push(...value);
      }

      this.imagesUploadedRes = this.imagesUploaded;
    });
  }

  async destroyImage(index) {
    try {
      this.removeImage(index);
    } catch (err) {
      console.error(err);
    }
  }

  async uploadImage(event) {
    try {
      const files = (<HTMLInputElement>event.target).files;
      !this.imagesUploaded[this.type] && (this.imagesUploaded[this.type] = []);
      !this.imagesUploadInSave[this.type] &&
        (this.imagesUploadInSave[this.type] = []);
      if (
        this.multiple &&
        this.imagesUploaded[this.type]?.length + files.length > 5
      ) {
        const translate = this.translateSv.instant('MAXIMO_5_IMAGENES');
        return this.uiSv.showToast(translate);
      }
      const res: any[] = await this.fileService.uploadImages(files);
      if (this.saveInUpload) {
        for (const image of res) {
          this.uploadingImage = true;
          const formData = new FormData();
          formData.append(this.type, image.file);
          formData.append('type', this.type);
          const uploadFile: any = await this.httpSv.itemAction(
            formData,
            'images',
            'store'
          );
          image.url = uploadFile.data;
          this.uploadingImage = false;
          this.imagesUploadInSave[this.type].push(uploadFile.data);
        }
      }

      if (this.multiple) {
        this.imagesUploaded[this.type].push(...res);
      } else {
        this.imagesUploaded[this.type] = res;
      }
      this.fileService.emptyArr();
      this.saveImg.emit(
        this.saveInUpload ? this.imagesUploadInSave : this.imagesUploaded
      );
      event.target.value = null;
    } catch (err) {
      console.error(err);
      if (err.name === 'HttpErrorResponse') {
        const translate = this.translateSv.instant(
          'NO_SE_PUDO_SUBIR_LA_IMAGEN_INTENTALO_NUEVAMENTE'
        );
        await this.uiSv.showToast(translate);
        this.uploadingImage = false;
        event.target.value = null;
        this.fileService.emptyArr();
      }
    }
  }

  async removeImage(index) {
    try {
      if (this.saveInUpload) {
        const image = this.imagesUploaded[this.type][index];
        const body: any = {
          type: this.type,
          file:
            typeof image?.file === 'object'
              ? image?.url
              : image?.file || image?.url,
        };

        let fixType = this.fixedType.slice(0, this.fixedType.length - 1);
        if (fixType === 'gallerie') fixType = 'gallery';
        if (!this._isCopy) {
          if (
            this.imagesUploaded[this.type] &&
            (image?.product_id || image?.galleryId)
          ) {
            body.id = image?.product_id || image?.galleryId;
          } else if (this.id) {
            body.id = this.id;
          }
          await this.httpSv.itemAction(body, 'images', 'destroy');
        }
        this.imagesUploadInSave[this.type] &&
          this.imagesUploadInSave[this.type].splice(index, 1);

        // body.id ? `${fixType}/files` :
      } else {
        this.saveImg.emit(this.imagesUploadInSave);
      }
      this.removeImg.emit({
        type: this.type,
        img: this.imagesUploaded[this.type][index],
      });
      this.imagesUploaded[this.type].splice(index, 1);
    } catch (err) {
      console.error(err);
    }
  }
}
